import React from 'react';
import { Avatar } from 'antd';
import type { AvatarProps } from 'antd';
import classnames from 'classnames';
import cn from './styles.module.scss';

export type HeaderAvatarProps = AvatarProps;

export const HeaderAvatar = ({ className, ...rest }: HeaderAvatarProps) => {
  return <Avatar className={classnames(cn.avatar, className)} {...rest} />;
};
